import Logo from "@commons/Logo";
import NavbarList from "./NavbarList";

function Navbar() {
  return (
    <nav
      className="left-0 top-0 h-full bg-white shadow-lg flex-col items-center py-6 gap-6 z-30 w-42 md:w-60 xl:w-68 hidden md:flex"
      role="navigation"
      data-testid="navbar"
    >
      <Logo />
      <NavbarList />
    </nav>
  );
}
export default Navbar;
